import React from 'react';
import PropTypes from 'prop-types';
import { Body, CenteredContainer, Title, Type } from '@nerdwallet/currency';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Image from '@nerdwallet/react-image';

const ReasonsToBelieve = ({ eyebrow, title, bullets, imageUrl }) => (
  <ElementImpression
    elementDomType="div"
    elementName="ReasonsToBelieve"
    id="reasons-to-believe"
  >
    <CenteredContainer className="reasons">
      <div className="reasons__content">
        <div className="reasons__copy">
          <Type light uppercase size={1} bold>
            {eyebrow}
          </Type>
          <Title size="large" className="reasons__heading">
            {title}
          </Title>
          <div className="reasons__bullets">
            {bullets.map((bullet) => (
              <div className="reasons__bullet" key={bullet.title}>
                <Title component="h3">{bullet.title}</Title>
                <Body>{bullet.content}</Body>
              </div>
            ))}
          </div>
        </div>
        {imageUrl ? (
          <div className="reasons__image">
            <Image
              src={imageUrl}
              alt=""
              naturalWidth={1206}
              naturalHeight={1344}
              backgroundColor="transparent"
              role="presentation"
            />
          </div>
        ) : null}
      </div>
    </CenteredContainer>
  </ElementImpression>
);

ReasonsToBelieve.propTypes = {
  bullets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
  eyebrow: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
};

ReasonsToBelieve.defaultProps = {
  eyebrow: 'You got this',
  title: 'Everything you need — totally free',
  bullets: [],
};

export default ReasonsToBelieve;
